export class IssueLink {
  id: number;
  issueKey: string;
  issueId: number;

  constructor(id: number, issueKey: string, issueId: number) {
    this.id = id;
    this.issueKey = issueKey;
    this.issueId = issueId;
  }
}
